/* eslint-disable react-hooks/exhaustive-deps */
import { USER_ROLE } from 'constants/common';
import React, { useEffect } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import DropDownInput from 'components/input/DropDownInput';
import AdvSelectSearchInput from 'components/input/AdvSelectSearchInput';
import AutocompleteInput from 'components/input/AutoCompleteInput';
import { Typeahead } from 'react-bootstrap-typeahead';
import toast from 'react-hot-toast';
import { states_usa } from 'components/helper/state_usa';
import courseServices from 'services/courseServices';
import collegeServices from 'services/collegeServices';
import { checkEnableParseJSON, userpilotDomain } from 'components/helper/helper';
import { useHistory } from 'react-router';
import { routers } from 'router/router';
import { useAppDispatch } from 'app/hooks';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import { getAccessToken, getUserId, getUserRole, removeAccessToken, removeUserId } from 'utils/sessionStorage';
import authorizationServices from 'services/authorizationServices';
import { Userpilot } from 'userpilot';
import { useFormik } from 'formik';
import moment from 'moment';
import { updateHighSchool } from 'app/highSchoolSlice/highSchoolSlice';

interface Props {
  onNextStep: (step: string) => void;
  formik: any;
}
  
const FormStudentInfo = ({ formik, onNextStep }: Props) => {
    const finishYearOptions = [0, 1, 2, 3, 4, 5, 6, 7].map((i) => i + new Date().getFullYear()-1);
    const [majorOptions, setMajorOptions] = React.useState<any[]>([]);
    const [highSchoolData, setHighSchoolData] = React.useState<any[]>([]);
    const [loading, setLoading] = React.useState(false);
    let searchCtrl = new AbortController();
    const typeahead = React.createRef<typeof Typeahead>();
    let history = useHistory();
    const dispatch:any = useAppDispatch();
    let studentId = getUserId();
    let token = getAccessToken();
    const role = USER_ROLE.student;

    const searchMajor = async () => {
        const result = await collegeServices.getMajorInterestCategoryOptions('');
        if (result.length) setMajorOptions(result);
      };

    const updateHighSchoolInfo = async(values:any) => {
        const high_school_info = {
          where_attend_high_school: values.additional_info?.where_attend_high_school ?? '',
          state:  values.additional_info?.state ?? '',
          city: values.additional_info?.city ?? '',
          country:  values.additional_info?.country ?? '',
          is_home_school: false,
          is_independant_study: false,
          my_home_school_associated_with_high_school: false,
          school_name:  values.additional_info?.school_name ?? '',
          school_type: '',
          left_highschool_reason: '',
          academic_history: 'None',
        };

        const initialValues = {
          high_school_array: '',
          number_of_other_school_attended: '0',
          other_school_array: '',
          graduating_school_array: '',
          counselor_prefix: '',
          counselor_first_name: '_',
          counselor_middle_initial: '',
          counselor_last_name: '_',
          counselor_job_title: '',
          counselor_email: '',
          counselor_country_code: '',
          counselor_phone_number: '',
        };
        const otherSchoolData = [{}];
        const graduating_school_array = {
          graduating_date_received: null,
          graduation_status: 'I will not be receiving a high school diploma or equivalent',
          graduating_high_school: '',
          graduating_school_year: '9th',
          graduating_school_gpa_type: 'Weighted',
          graduating_school_gpa_scale: '4',
          graduating_school_cumulative_gpa: 0,
          graduating_school_rank_report: 'Exact',
          graduating_school_class_size: '',
          graduating_class_size: null,
          class_rank_reporting: 'Exact',
          class_rank: 0,
          decile_rank: '',
          quintile_rank: '',
          quartile_rank: '',
          gpa_scale_reporting: null,
          culmative_gpa: null,
          gpa_weighting: 'Weighted',
          gpa_scale_other: '',
          rank_weighting: 'Weighted',
          progression_is_graduate_early: false,
          progression_is_graduate_late: false,
          progression_is_time_off: false,
          progression_is_take_gap_year: false,
          progression_is_no_change: true,
        };

        let _state = values?.high_school_object?.state ?? '';
        let _country = values?.high_school_object?.country ?? '';
        let _where_attend_high_school = 'IN_CA';
        if (_state==='CA') {
          _where_attend_high_school = 'IN_CA';
          _country = "United States of America"; // force update
        }
        else 
        if (_state!=='CA' && _country==="United States of America") {
          _where_attend_high_school =  'OUTSIDE_CA';
        }
        else {
          _where_attend_high_school =  'OUTSIDE_USA';
        }

        const high_school_array = [{
          high_school_object: {
            college_board_code: values?.high_school_object?.college_board_code ?? '',
            school_name: values?.high_school_object?.school_name ?? '',
            school_type: values?.high_school_object?.school_type ?? '',
            city: values?.high_school_object?.city ?? '',
            state: values?.high_school_object?.state ?? '',
            zip: values?.high_school_object?.zip ?? '',
            country: values?.high_school_object?.country ?? '',
            csu_name: values?.high_school_object?.csu_name ?? '',
            uc_name: values?.high_school_object?.uc_name ?? '',
            cm_name: values?.high_school_object?.cm_name ?? '',
            match_all: values?.high_school_object?.match_all ?? false,
            label: values?.high_school_object?.label ?? '',
            code: values?.high_school_object?.code ?? null,
            is_manual: false,
          } as any,
          where_attend_high_school: _where_attend_high_school,
          state: _state,
          city: values?.high_school_object?.city ?? '',
          csu_city: values?.high_school_object?.city ?? '',
          country: _country,
          is_home_school: false,
          is_independant_study: false,
          my_home_school_associated_with_high_school: false,
          school_name: values?.high_school_object?.school_name ?? '',
          school_type: '',
          high_school_name: values?.high_school_object?.school_name ?? '',
          high_school_code: values?.high_school_object?.code ?? null,
          high_school_status: '',
          start_date: moment().toISOString(),
          end_date: moment().add(1, 'M').toISOString(),
          progression_is_graduate_early: false,
          progression_is_graduate_late: false,
          progression_is_time_off: false,
          progression_is_no_change: false,
          progression_is_take_gap_year: false,
          is_boarding_school: '',
          is_graduate_from_this_school: '',
          is_live_on_campus: '',
          degree: 'High School/Secondary School Diploma',
          month: 'January',
          day: '1',
          year: `${new Date().getFullYear()-4}`,
          grade: [],
          academic_year: [],
          is_summer_took: [],
          specialized_curriculum_career: false,
          specialized_curriculum_international: false,
          specialized_curriculum_magnet: false,
          specialized_curriculum_other: false,
          specialized_curriculum_other_free_text: '',
          grading_scale: '',
          grading_scale_is_abcdf: false,
          grading_scale_is_0_100: false,
          grading_scale_is_1_7: false,
          grading_scale_is_other: false,
          other_grading_system: '',
          is_block_scheduling: false,
          change_in_progression_through_highschool: '',
          degreeFreeText: '',
          lowest_number_grade: '',
          highest_number_grade: '',
          classes_schedule: "Semester (2 final grades per year)",
          graduating_high_school: '',
          school_term_1: false,
          school_term_2: false,
          school_term_3: false,
          school_term_4: false,
          graduation_status: '',
          academic_performance: '',
          name_of_degree: '',
          allNoneAGCourses: false,
          have_other_grading_system: 'false',
          second_grading_system: '',
          gradeIsNew: [],
        }];

       
        const newValues = {
          ...initialValues,
          student_id: studentId,
          high_school_array: JSON.stringify(high_school_array),
          other_school_array: JSON.stringify(otherSchoolData),
          graduating_school_array: JSON.stringify(graduating_school_array),
          high_school_info: JSON.stringify(high_school_info),
        };
        await dispatch(updateHighSchool(newValues));
    }

    const formCreateInfo = useFormik({
      initialValues: {
        email: '',
        first_name: '',
        last_name: '',
        user_role: USER_ROLE.student,
        school_or_organization_work_with: '',
        year_finish_high_school: '',
        password: '',
        password_confirm: '',
        additional_info: {
          where_attend_high_school: '',
          school_system: '',
          high_school_name: '',
          majors_interest_1: '',
          majors_interest_2: '',
          year_plan_college_studies: '',
        },
      },
      validateOnChange: true,
      validateOnBlur: false,
      validate: (values) => {
        const errors: { year_finish_high_school?: string } = {};
        const y = values.year_finish_high_school;
        if (y === '' || y === null || y === undefined) {
          errors.year_finish_high_school = 'Please select your graduation year.';
        }
        return errors;
      },
      onSubmit: async (values:any) => {
        try {
          sessionStorage.setItem('userRole',  role);

          await authorizationServices.updateStudent(studentId, {
            ...values,
            additional_info: JSON.stringify(formCreateInfo.values.additional_info),
          });
          Userpilot.identify((studentId ?? 'undefined') + userpilotDomain(role), {
            majors_interest_1:
              formCreateInfo.values.additional_info?.majors_interest_1 ?? 'undefined',
            majors_interest_2:
              formCreateInfo.values.additional_info?.majors_interest_2 ?? 'undefined',
            highSchool: [values.additional_info?.school_name ?? ''],
          });
  
          window.Intercom('update', {
            major_1: formCreateInfo.values.additional_info?.majors_interest_1 ?? '',
            major_2: formCreateInfo.values.additional_info?.majors_interest_2 ?? '',
          });

          //update high_school table
          await updateHighSchoolInfo(values);
  
          toast.success('Save successfully');
          onNextStep('phone');
        } catch (ex) {
          console.log('Error: ', ex);
        }
      },
    });
  
      
    useEffect(() => {
      searchMajor();
    }, []);


    const handleLogout = () => {
      dispatch(logout());
      removeAccessToken();
      removeUserId();
      history.push(routers.login.path);
    };

    React.useEffect(() => {
      studentId = getUserId();
      token = getAccessToken();
      if (token && studentId) {
        setLoading(true);
        authorizationServices.getStudent(studentId).then((res: any) => {
          setLoading(false);
          if (res) {
            // API often omits `user_role`; full reset would drop it → Graduation year hides (DropDownInput hidden prop).
            formCreateInfo.resetForm({
              values: {
                ...res,
                user_role: res?.user_role ?? USER_ROLE.student,
                additional_info: checkEnableParseJSON(res.additional_info),
              },
            });
          }
        });
        sessionStorage.setItem('userRole',  USER_ROLE.student);
      } else {
        handleLogout();
      }
    }, []);

    const getStateName = (stateCode: string) => {
      for (let i = 0; i < states_usa.length; i++) {
          if (states_usa[i].value === stateCode) return states_usa[i].name;
      }
      return stateCode;
    };


    const handleChangeItem = (item: any) => {
        try {
          formCreateInfo.setFieldValue('high_school_code', item?.code);
          formCreateInfo.setFieldValue('high_school_object', item);
          formCreateInfo.setFieldValue('schoolId', item?.id);
          console.log('item: ', item);
          //#region update additional_info
          let info:any = Object.assign({}, formCreateInfo.values.additional_info);
          info.high_school_name = item?.school_name ?? '';
          info.state = item?.state ?? '';
          info.city = item?.city ?? '';
          info.country = item?.country ?? '';
          formCreateInfo.setFieldValue('additional_info', info);
          //#endregion
        } catch (ex) {}
    };

    const handleSearchHighSchool = async (keyword: string) => {
        setLoading(true);
        if (keyword.length < 1) return;
        searchCtrl.abort();
        searchCtrl = new AbortController();
        try {
          const body = {
            keyword: keyword,
            options: formCreateInfo.values.additional_info?.where_attend_high_school,
            state: (formCreateInfo.values as any)?.state ?? '',
            country:
            formCreateInfo.values.additional_info?.where_attend_high_school === 'OUTSIDE_CA'
                ? 'United States of America'
                : '',
          };
          let res: any = await courseServices.getSchoolSuggest(body, searchCtrl);
    
          const data = res.map((item: any) => ({
            ...item,
            label:
              `${item.high_school_point ?? item.school_name}` +
              ` (code: ${item?.college_board_code ?? ''}, city: ${item.city ?? ''}, state: ${
                getStateName(item.state) ?? ''
              }, country: ${item.country ?? ''})`,
            code: item.college_board_code,
            name: `${item.high_school_point ?? item.school_name}`
          }));
    
          setHighSchoolData(data);
          setLoading(false);
        } catch (error: any) {
          setLoading(false);
         }
    };

    const handleSkipNow = async () => {
        onNextStep('phone');
    }

    const showGraduationYearError =
      formCreateInfo.submitCount > 0 &&
      Boolean(formCreateInfo.errors.year_finish_high_school);

    return (
    <div className="min-h-screen flex items-center justify-center p-0 mb-5 px-md-5 container">
      <div className="w-full max-w-lg mx-auto">             
        <div id="title-section" className="d-block text-center mb-8">
            <div className="inline-flex items-center justify-center w-14 h-14 bg-gradmap-blue rounded-xl mb-4">
                <i className="text-white text-2xl" data-fa-i2svg=""><svg className="svg-inline--fa-24px fa-graduation-cap" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="graduation-cap" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" data-fa-i2svg=""><path fill="currentColor" d="M320 32c-8.1 0-16.1 1.4-23.7 4.1L15.8 137.4C6.3 140.9 0 149.9 0 160s6.3 19.1 15.8 22.6l57.9 20.9C57.3 229.3 48 259.8 48 291.9v28.1c0 28.4-10.8 57.7-22.3 80.8c-6.5 13-13.9 25.8-22.5 37.6C0 442.7-.9 448.3 .9 453.4s6 8.9 11.2 10.2l64 16c4.2 1.1 8.7 .3 12.4-2s6.3-6.1 7.1-10.4c8.6-42.8 4.3-81.2-2.1-108.7C90.3 344.3 86 329.8 80 316.5V291.9c0-30.2 10.2-58.7 27.9-81.5c12.9-15.5 29.6-28 49.2-35.7l157-61.7c8.2-3.2 17.5 .8 20.7 9s-.8 17.5-9 20.7l-157 61.7c-12.4 4.9-23.3 12.4-32.2 21.6l159.6 57.6c7.6 2.7 15.6 4.1 23.7 4.1s16.1-1.4 23.7-4.1L624.2 182.6c9.5-3.4 15.8-12.5 15.8-22.6s-6.3-19.1-15.8-22.6L343.7 36.1C336.1 33.4 328.1 32 320 32zM128 408c0 35.3 86 72 192 72s192-36.7 192-72L496.7 262.6 354.5 314c-11.1 4-22.8 6-34.5 6s-23.5-2-34.5-6L143.3 262.6 128 408z"></path></svg></i>
            </div>
            <h1 className="text-3xl font-bold text-gray-900 mb-2">Tell us a little about you</h1>
            <p className="text-gray-600">Help us personalize your GradMap experience</p>
        </div>
        <div id="setup-form-container" className="bg-white rounded-2xl shadow-xl border border-gray-100 p-8">
            <div className="row">
            <div className="col-md-12">
              <DropDownInput
                form={formCreateInfo}
                values={formCreateInfo.values.year_finish_high_school}
                onChange={formCreateInfo.handleChange}
                name={'year_finish_high_school'}
                label={'Graduation year'}
                labelClass="block text-sm font-semibold text-gray-900 mb-2"
                labelCustom={(<span className="text-red-500">*</span>)}
                option={finishYearOptions}
                disableAutoSelectFirst
                placeholder="Select graduation year"
                isMissing={showGraduationYearError}
                feedback={
                  showGraduationYearError && (
                    <span className="text-danger">{formCreateInfo.errors.year_finish_high_school}</span>
                    )
                }
              />
            </div>
            </div>
            <div className="row">
            <div className="col-md-12 mt-6">
                <AdvSelectSearchInput
                icon={<SearchIcon />}
                mdCol="12"
                form={formCreateInfo}
                values={formCreateInfo.values.additional_info?.high_school_name ?? ''}
                name="additional_info.high_school_name"
                label={'High school name'}
                labelCustom={(<span className="ml-1 text-gray-400 font-normal">(optional)</span>)}
                feedback={(<span title="Search by CEEB code, City, County/Region/Territory, High School Name">We'll help you find colleges that students from your school typically attend</span>)}
                option={highSchoolData}
                onChangeItem={handleChangeItem}
                onSearch={(keyword: string) => handleSearchHighSchool(keyword)}
                logo="span-uc-logo"
                isLoading={loading}
                inputRef={typeahead}
                emptyLabel={<></>}
                clearOption={()=>{setHighSchoolData([])}}
                />                          
            </div>
            </div>
            <div className="row">
            <div className="col-md-12 mt-6">
                <AutocompleteInput
                onChange={(val: any) => {
                  formCreateInfo.setFieldValue('additional_info.majors_interest_1', val);
                }}
                option={majorOptions}
                label="Intended major(s)"
                labelCustom={(<span className="ml-1 text-gray-400 font-normal">(optional)</span>)}
                name="additional_info.majors_interest_1"
                values={formCreateInfo.values.additional_info?.majors_interest_1}
                mdCol={'6'}
                feedback={(<p className="mt-2 text-xs text-gray-500">You can add or change this later</p>)}
                placeholder="e.g. Computer Science, Biology"
                />
            </div>
            </div>

            <div className="pt-4">
                <button type="button"
                  className="w-full bg-gradmap-blue hover:bg-gradmap-navy text-white font-semibold py-4 rounded-lg transition-all duration-200 shadow-lg shadow-blue-500/30 hover:shadow-xl hover:shadow-blue-600/40 flex items-center justify-center space-x-2"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    formCreateInfo.handleSubmit();
                  }}
                >
                    <span>Go to my dashboard</span>
                    <i data-fa-i2svg=""><svg className="svg-inline--fa fa-arrow-right" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"></path></svg></i>
                </button>
            </div>

            <div className="text-center mt-6">
                <button type="button" 
                    className="text-gray-600 hover:text-gradmap-blue font-medium text-sm transition-colors"
                    onClick={handleSkipNow}    
                >
                    Skip for now
                </button>
            </div>
        </div>
        <div className="mt-6 text-center">
            <div className="flex items-center justify-center space-x-2 text-sm text-gray-500">
                <i className="text-xs" data-fa-i2svg="">
                    <svg className="svg-inline--fa fa-lock" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="lock" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M144 144v48H304V144c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48h16c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80z"></path></svg>
                    </i>
                <p>Your information is private and secure</p>
            </div>
        </div>
      </div>  
    </div>
    );
};


export default FormStudentInfo;